import React from 'react';
import { formatGold } from '../../utils/goldNotation';
import { splitSegments } from '../../utils/transparency';

const COLORS = {
  admin: 'bg-orange-500',
  treasury: 'bg-purple-500',
  players: 'bg-cyan-500',
};

const SplitBar = ({ summary }) => {
  const segments = splitSegments(summary);

  return (
    <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl space-y-4">
      <h2 className="text-xl font-bold text-white">Divisão do prêmio</h2>
      <div className="flex h-4 w-full overflow-hidden rounded-full bg-white/10">
        {segments.map((s) => (
          <div key={s.key} className={COLORS[s.key]} style={{ width: `${s.percent}%` }} />
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {segments.map((s) => (
          <div key={s.key} className="flex items-center gap-2">
            <span className={`w-3 h-3 rounded-full ${COLORS[s.key]}`} />
            <span className="text-gray-300 text-sm">{s.percent}% {s.label}</span>
            <span className="text-white text-sm font-semibold ml-auto" title={Number(s.amount).toLocaleString('pt-BR')}>
              {formatGold(s.amount)}
            </span>
          </div>
        ))}
      </div>
      <p className="text-center text-gray-400 text-sm">
        Total arrecadado:{' '}
        <span className="text-white font-semibold" title={Number(summary.prizeAmount).toLocaleString('pt-BR')}>
          {formatGold(summary.prizeAmount)}
        </span>
      </p>
    </div>
  );
};

export default SplitBar;
